module.exports = __webpack_public_path__ + "img/4.90644f11.png";